/**
 * After an account has been deleted.
 *
 * Rendered without Clerk, like the share page, because the person it is for no
 * longer has a sign-in — and a sign-in form is the one thing that must not greet
 * somebody who has just asked to be forgotten.
 *
 * It says exactly what happened, including the one part that can fail after
 * everything else has gone: removing the sign-in itself. If that did not work, the
 * person is told so plainly and given somewhere to write, rather than being left to
 * find out when a password reset still arrives.
 */
import { Note } from "../ui/index.js";

export function Goodbye({ cancelled, signInRemoved }: { cancelled: boolean; signInRemoved: boolean }) {
  return (
    <div className="shared">
      <header className="shared__bar">
        <img src="/logo.svg" alt="BroadPaper" className="shared__logo" />
      </header>
      <div className="shared__card" style={{ gap: 14 }}>
        <span className="empty__mark" />
        <h1>Your account has been deleted</h1>
        <p className="muted">
          Your data, designs, documents and share links have been permanently removed{cancelled ? ", and your subscription has been cancelled" : ""}.
        </p>
        {signInRemoved ? (
          <p className="muted">Your BroadPaper sign-in has been removed too. Thank you for trying BroadPaper.</p>
        ) : (
          <Note tone="ask" title="We couldn't remove your sign-in">
            Everything else is gone, but your BroadPaper sign-in still exists. Email{" "}
            <a href="mailto:support@broadpaper.com?subject=Please%20remove%20my%20sign-in">support@broadpaper.com</a> and we will remove it by hand.
          </Note>
        )}
        <a className="btn" href="https://www.broadpaper.com/">
          Go to broadpaper.com
        </a>
      </div>
    </div>
  );
}
